export default __webpack_public_path__ + "static/media/guia-4-2.3ee3b5cf.svg";